module.exports = __webpack_public_path__ + "img/1504367707.6b76027e.jpg";